@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";

    // Consectutive staggered split blocks get negative margin
    @media ($above-mobile) {
        & :global(.staggeredSplitBlockGlobal) {
            + :global(.staggeredSplitBlockGlobal) {
                margin-top: calc(var(--spacer-80) * -1);
            }
        }
    }

    // Split blocks get auto spacers on mobile when they're in the same BlockGroup
    @media ($below-mobile) {
        & :global(.splitBlockGlobal) {
            + :global(.splitBlockGlobal) {
                margin-top: var(--spacer-40);
            }
        }

        & :global(.staggeredSplitBlockGlobal) {
            + :global(.staggeredSplitBlockGlobal) {
                margin-top: var(--spacer-80);
            }
        }
    }
}

.width12 {
    --grid-column: 1 / span 12;
}

.width10 {
    --grid-column: 2 / span 10;
}

.width8 {
    --grid-column: 3 / span 8;
}

.width6 {
    --grid-column: 4 / span 6;
}

.width10,
.width8,
.width6 {
    @media ($below-tablet) {
        --grid-column: 1 / -1;
    }
}

.inner {
    grid-column: var(--grid-column);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}
